module.exports = fox._r("images/home-hover.png", __webpack_public_path__ + "images/home-hover.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/home-hover.png
// module id = 1057
// module chunks = 4